var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYoutubeFollow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.9,
    height: 35.046,
    viewBox: "0 0 49.9 35.046",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "youtube_1_",
    "data-name": "youtube (1)",
    transform: "translate(-5.368 -13.434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9511",
    "data-name": "Path 9511",
    d: "M41.272,31.81c-4.942-2.641-9.674-5.069-14.511-7.6V39.371c5.09-2.767,10.455-5.3,14.532-7.561h-.021Z",
    transform: "translate(-2.174 -1.334)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9512",
    "data-name": "Path 9512",
    d: "M41.272,31.81c-4.942-2.641-14.511-7.6-14.511-7.6l12.758,8.575S37.2,34.07,41.272,31.81Z",
    transform: "translate(-2.172 -1.047)",
    fill: "#e8e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9513",
    "data-name": "Path 9513",
    d: "M26.034,48.436c-9.5-.175-12.749-.332-14.744-.743a6.481,6.481,0,0,1-3.383-1.759,7.121,7.121,0,0,1-1.6-3.09,20.211,20.211,0,0,1-.684-4.536,107.754,107.754,0,0,1,0-14.705c.306-2.716.454-5.941,2.483-7.822A6.657,6.657,0,0,1,11.427,14.1c1.955-.371,10.286-.665,18.909-.665,8.6,0,16.953.293,18.91.665a6.505,6.505,0,0,1,3.891,2.307c1.852,2.913,1.884,6.534,2.072,9.367.078,1.35.078,9.014,0,10.364-.293,4.477-.528,6.061-1.192,7.7a5.679,5.679,0,0,1-1.369,2.19,6.559,6.559,0,0,1-3.481,1.779c-8.224.618-15.207.753-23.133.626Zm12.594-17.99C34.053,28,29.672,25.734,25.194,23.387V37.428c4.712-2.562,9.68-4.909,13.454-7l-.019.019Z",
    transform: "translate(0)",
    fill: "#cd201f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeFollow);
export default __webpack_public_path__ + "static/media/youtube-follow.6d2e583ebe6cc0162f75d8af57e8385c.svg";
export { ForwardRef as ReactComponent };